import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { httpClient } from '../restClient';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { orderBy } from 'lodash';
import { CSVLink } from 'react-csv'
import { Tooltip } from '@material-ui/core';

const styles = theme => ({
    container: {
      marginTop: "20px",
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: "10px",
      marginRight: "10px",
      width: 300,
    },
    textFieldSmall: {
      marginLeft: "10px",
      marginRight: "10px",
      width: 150,
    },
    dateField: {
      marginLeft: "10px",
      marginRight: "10px",
      width: 200,
    },
    sendButton:{
      height:"30px",
      width:"150px"
    },
    resultItem:{
      marginTop:"5px"
    },
    resultSection:{
      marginTop:"15px",
      paddingLeft:"10px"
    },
    progressSpinner: {
      color: green[700],
      position: 'absolute'
    },
    table: {
      maxWidth: 650,
    },
    tableHeaderCell: {
      fontWeight: "bold",
      padding: "4px",
      paddingLeft: "24px"
    },
    tableNameCell: {
      maxWidth: 200,
      padding: "4px",
      paddingLeft: "24px"
    },
    tableCell: {
      maxWidth: 100,
      padding: "4px",
      paddingLeft: "24px"
    },
    criticalityCell: {
      maxWidth: 100,
      padding: "4px",
      paddingLeft: "24px",
    }
  });

class AlarmReport extends Component {
    state = {
        bussit: [],
        alarmReports: [],
        progress: false,
        from_date: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split("T")[0],
        to_date: (new Date()).toISOString().split("T")[0]
    };
    componentDidMount() {}
    
    getAlarmReports = () => {
      this.setState({progress:true});
      this.getAlarmReportsByBusinesses()
    }
    
    getAlarmReportsByIds = (ids) => {
      var self=this;
      let searchBusinessIdArray = []
      let searchBusinessIdArrays = []
      ids.map((businessId, i) => {
        if ((i > 0 && i % 8 === 0) ){
          searchBusinessIdArrays.push(searchBusinessIdArray)
          searchBusinessIdArray = []
          searchBusinessIdArray.push(businessId)
        } else if (i === businessId.length - 1) {
          searchBusinessIdArrays.push(searchBusinessIdArray)
        } else {
          searchBusinessIdArray.push(businessId)
        }
      })
      searchBusinessIdArrays.map(businessIdArray => {
        const businessIds = businessIdArray.join(',')
        var uri = `/api/business_alarm_reports?ids=${businessIds}`+ "&from_date=" + this.state.from_date + "&to_date=" + this.state.to_date + "&priority=" +this.state.priority;
        let reports = self.state.alarmReports
        httpClient(uri, {}).then(response => {
          response.json.map(report => {
            reports.push(report)
          })
          self.setState({alarmReports:reports});
        })
      })
      this.setState({progress:false})
    }

    getAlarmReportsByBusinesses = () => {
      var self=this;
      var uri = "/api/business_alarm_reports_businesses";
      httpClient(uri, {}).then(response => { 
        let businesses = []
        response.json.map(bussi => businesses.push(bussi.id))
        self.getAlarmReportsByIds(businesses)
      })
    }

      handleChange = name => event => {
        let value = event.target.value;
        this.setState({ [name]: value });
      }

      criticalityColor = (value) => {
        if (value <= 2){
          return 'LightGreen'
        } else if (value <= 5 && value > 2) {
          return 'yellow'
        } else if (value >= 6 && value < 8) {
          return 'orange'
        } else if (value > 7) {
          return 'Crimson'
        }
      }

render() {
    const { classes } = this.props;
    return (
        <div>
          <div>
            {"Alarm report"}
            <form className={classes.container} noValidate>
            <TextField
              id="from_date"
              label="From date"
              type="date"
              defaultValue={this.state.from_date}
              onChange={this.handleChange("from_date")}
              className={classes.dateField}
              InputLabelProps={{
                shrink: true,
              }} />
            <TextField
              id="to_date"
              label="Until/Trough date"
              type="date"
              defaultValue={this.state.to_date}
              onChange={this.handleChange("to_date")}
              className={classes.dateField}
              InputLabelProps={{
                shrink: true,
              }} />
            <TextField
              id="priprity"
              label="Priority (1,2,3)"
              type="text"
              defaultValue={''}
              onChange={this.handleChange("priority")}
              className={classes.textFieldSmall}
              InputLabelProps={{
                shrink: true,
              }} />
            <Button
              onClick={this.getAlarmReports}
              size="small"
              variant="raised"
              color="secondary"
              className={classes.sendButton}
              >
              {"Send"}
            </Button>
           <CSVLink data={this.state.alarmReports} target="_blank" filename='AlarmReportData' separator=';'>
            <Button>{"Download Excel"}</Button>
           </CSVLink>
            </form>
          </div>
            <div className={classes.resultSection}>
            {this.state.progress && (
            <CircularProgress size={100} className={classes.progressSpinner} />
          )}
            {true && <React.Fragment>
            {<Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeaderCell}>Nr.</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Business name</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Member Count</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Creator Count</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Team Count</TableCell>
                    <TableCell className={classes.tableHeaderCell}>{`Games Created Since ${this.state.from_date} Until ${this.state.to_date}`}</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Games Played of Those Games</TableCell>
                    <TableCell className={classes.tableHeaderCell}>{"Games Played By ID (Same Period)"}</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Void Days</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Good Through</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Days Left to Renewal</TableCell>
                    <Tooltip disableFocusListener disableTouchListener title={"Calculated from Void Days, Games Played By ID and Days Left to  Renewal"}>
                    <TableCell className={classes.tableHeaderCell}>Criticality</TableCell>
                    </Tooltip>
                    <TableCell className={classes.tableHeaderCell}>Priority</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {orderBy(this.state.alarmReports, 'criticality', 'desc').map((bus, i) => (
                <TableRow key={i}>
                  <TableCell className={classes.tableCell}>{i + 1}</TableCell>
                  <TableCell className={classes.tableNameCell}>{bus.business_name}</TableCell>
                  <TableCell className={classes.tableCell}>{bus.member_count}</TableCell>
                  <TableCell className={classes.tableCell}>{bus.creators_count}</TableCell>
                  <TableCell className={classes.tableCell}>{bus.teams_total_last_year_in_all_games}</TableCell>
                  <TableCell className={classes.tableCell}>{bus.games_created_in_year}</TableCell>
                  <TableCell className={classes.tableCell} style={{backgroundColor: 'pink', fontWeight: 'bold'}}>{bus.games_played}</TableCell>
                  <TableCell className={classes.tableCell}>{bus.games_played_by_ID}</TableCell>
                  <TableCell className={classes.tableCell}>{bus.void_days}</TableCell>
                  <TableCell className={classes.tableCell}>{bus.good_trough}</TableCell>
                  <TableCell className={classes.tableCell}>{bus.day_diff}</TableCell>
                  <TableCell className={classes.tableCell} style={{backgroundColor: this.criticalityColor(bus.criticality), fontWeight: 'bold' }}>{bus.criticality}</TableCell>
                  <TableCell className={classes.tableCell}>{bus.priority}</TableCell>
                </TableRow>))}
                </TableBody>
            </Table>}
          </React.Fragment>}
            </div>
        </div>
    )
}
}

export default withStyles(styles)(AlarmReport);


// WEBPACK FOOTER //
// ./src/dashboard/AlarmReport.js